import { styled, Stack, spacing, withUtility, css, shape } from '@hub-la/design-system';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
const IconContainer = styled(Stack)(_t || (_t = _`
  padding: ${0};
  ${0};
`), spacing(3), withUtility(({
  palette
}) => {
  return css(_t2 || (_t2 = _`
      background: transparent;
      border: 1px solid ${0};
    `), palette('outline'));
}));
const Wrapper = styled(Stack)(_t3 || (_t3 = _`
  padding: ${0};
  margin-top: ${0} !important;
  border: 1px solid;
  border-radius: ${0};
  ${0}
`), spacing(4), spacing(6), shape('medium'), withUtility(({
  palette
}) => {
  return css(_t4 || (_t4 = _`
      background-color: ${0};
      border-color: ${0};
    `), palette('surface'), palette('outline'));
}));

export { IconContainer, Wrapper };
